var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable } from "mobx";
import { TopLeaguesConnectionWrapper as TopLeaguesConnection } from "../../connections";
import { addUniquenotEmptyElements } from "../../helpers";
export class TopLeaguesRetriever {
    constructor(meta, dataProvider, loadData, addData, changeData, deleteData) {
        this.isLoading = false;
        this.onInitialData = (response) => {
            this.isLoading = false;
            if (response.leagues && response.leagues.length) {
                this.loadData(response.leagues);
            }
        };
        this.connection = new TopLeaguesConnection(meta, {
            Initial: this.onInitialData,
            Add: addData,
            Change: changeData,
            Delete: deleteData,
            Error: (err) => {
                this.isLoading = false;
                console.error(err);
            }
        });
        this.dataProvider = dataProvider;
        this.loadData = loadData;
        this.requestTopLeague = {
            ids: [this.dataProvider.sportId],
            regionIds: addUniquenotEmptyElements(this.dataProvider.regionId || [])
        };
    }
    setRegionIds(regionId) {
        const uniqueRegionIds = addUniquenotEmptyElements(this.dataProvider.regionId.concat(regionId));
        this.requestTopLeague.regionIds = uniqueRegionIds;
    }
    removeRegionId() {
        this.requestTopLeague.regionIds = [this.dataProvider.regionId[0]];
    }
    load() {
        this.isLoading = true;
        this.connection.updateQuery(this.requestTopLeague);
    }
    deactivate() {
        this.connection.deactivate();
    }
}
__decorate([
    observable,
    __metadata("design:type", Boolean)
], TopLeaguesRetriever.prototype, "isLoading", void 0);
//# sourceMappingURL=TopLeaguesRetriever.js.map